import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useTealiumEventProperties, useTrackPageView } from '@grandvisionhq/svc-tealium/events';

const TealiumSearchPageView = ()=>{
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const searchPageView = React__default.useCallback(swcHelpers.asyncToGenerator(function*() {
        const commonUserProperties = yield getCommonUserProperties();
        if (!commonUserProperties) return;
        return swcHelpers.objectSpread({}, commonEventProperties, commonUserProperties, {
            id: 'VirtualPage-View',
            Page_Type: 'Search',
            Page_Section1: 'Search',
            Page_Design: 'Tiles&Pages'
        });
    }), // Only need to trigger this page view on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        getCommonUserProperties
    ]);
    useTrackPageView(searchPageView);
    return null;
};

export { TealiumSearchPageView };
//# sourceMappingURL=TealiumSearchPageView.js.map
